import { type SellerOrderCartData, type IBundleProduct } from 'cart'
import BaseServiceProvider from './BaseServiceProvider'

export const getDefaultFulfilmentResponse = (
  data: SellerOrderCartData[]
): SellerOrderCartData<IBundleProduct>[] => {
  return data.map((cart) => ({
    ...cart,
    locations: cart.locations.map((location) => ({
      ...location,
      parts: location.parts.map((part) => ({
        ...part,
        bundleCode: null,
        bundleDiscount: null,
        bundleId: null,
        bundleName: null,
        bundlePrice: null,
        bundled: false,
      })),
    })),
  }))
}

class BundlesServiceProvider extends BaseServiceProvider {
  constructor() {
    super(import.meta.env.VITE_API_BASE_URL, 'bundles', '1.1', 'bundles')
  }

  public checkFulfilment(
    data: SellerOrderCartData[]
  ): Promise<SellerOrderCartData<IBundleProduct>[]> {
    // Stop the request if there is no data to send.
    if (data.length === 0) {
      return Promise.resolve(getDefaultFulfilmentResponse(data))
    }
    return this.post<SellerOrderCartData<IBundleProduct>[]>(
      'checkFulfilment',
      data
    )
      .then((res) => {
        return res.data
      })
      .catch(() => {
        return getDefaultFulfilmentResponse(data)
      })
  }
}

export default new BundlesServiceProvider()
